import { useEffect, useState } from "react";

interface TelegramUser {
    id: number;
    first_name?: string;
    last_name?: string;
    username?: string;
    language_code?: string;
    [key: string]: unknown;
}

interface TelegramWebApp {
    initData: string;
    initDataUnsafe?: {
        user?: TelegramUser;
        [key: string]: unknown;
    };
    ready(): void;
    expand(): void;
    close(): void;
}

declare global {
    interface Window {
        Telegram?: {
            WebApp: TelegramWebApp;
        };
    }
}

/**
 * Хук для работы с Telegram WebApp в админке.
 * Определяет, запущено ли приложение внутри Telegram, и вытаскивает telegram_id пользователя.
 */
export function useTelegramWebApp() {
    const [isTelegramWebApp, setIsTelegramWebApp] = useState(false);
    const [telegramId, setTelegramId] = useState<number | null>(null);

    useEffect(() => {
        if (typeof window === "undefined" || !window.Telegram || !window.Telegram.WebApp) {
            return;
        }

        try {
            const webApp = window.Telegram.WebApp;
            setIsTelegramWebApp(true);

            // Инициализируем WebApp (по рекомендациям Telegram)
            webApp.ready();

            const unsafe = webApp.initDataUnsafe as any;
            const user = unsafe?.user as TelegramUser | undefined;

            if (user && user.id) {
                setTelegramId(user.id);
            }
        } catch (e) {
            // В случае ошибок просто не считаем среду Telegram
            // eslint-disable-next-line no-console
            console.error("Telegram WebApp init error", e);
        }
    }, []);

    return {
        isTelegramWebApp,
        telegramId,
    };
}

